import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Phone, MapPin, Mail, Instagram, Facebook } from 'lucide-react';
import { Button } from '../components/ui/button';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-black text-white font-sans selection:bg-yellow-500 selection:text-black">
      <Navbar />
      <div className="pt-32 pb-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
         <div className="text-center mb-16 animate-accordion-down">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
                Bize <span className="text-yellow-500">Ulaşın</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
                7/24 VIP transfer hizmetimiz için dilediğiniz zaman bizimle iletişime geçebilirsiniz.
            </p>
         </div>

         <div className="grid md:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div className="space-y-8">
                <div className="bg-[#1a1a1a] p-8 rounded-2xl border border-white/10 hover:border-yellow-500/50 transition-colors">
                    <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
                        <Phone className="h-6 w-6 text-yellow-500" /> İletişim Bilgileri
                    </h3>
                    <div className="space-y-4">
                        <a href="tel:+905468953037" className="flex items-center gap-4 text-gray-300 hover:text-white transition-colors p-4 bg-black/40 rounded-xl">
                            <span className="bg-yellow-500/10 p-3 rounded-full text-yellow-500">
                                <Phone className="h-5 w-5" />
                            </span>
                            <span className="text-lg font-medium">0546 895 30 37</span>
                        </a>
                        <div className="flex items-center gap-4 text-gray-300 p-4 bg-black/40 rounded-xl">
                            <span className="bg-yellow-500/10 p-3 rounded-full text-yellow-500">
                                <MapPin className="h-5 w-5" />
                            </span>
                            <span className="text-lg font-medium">Antalya, Türkiye</span>
                        </div>
                    </div>
                </div>

                <div className="bg-[#1a1a1a] p-8 rounded-2xl border border-white/10 hover:border-yellow-500/50 transition-colors">
                     <h3 className="text-2xl font-bold mb-6">Sosyal Medya</h3>
                     <div className="flex gap-4">
                        <a href="https://www.instagram.com/koparansahin?igsh=MWMzaGd5bjRoc3pjeQ==" target="_blank" rel="noopener noreferrer" className="bg-white/5 p-4 rounded-xl hover:bg-yellow-500 hover:text-black transition-all transform hover:scale-110 text-white">
                            <Instagram className="h-8 w-8" />
                        </a>
                        <a href="https://www.facebook.com/share/17xjjTzz7w/" target="_blank" rel="noopener noreferrer" className="bg-white/5 p-4 rounded-xl hover:bg-blue-600 hover:text-white transition-all transform hover:scale-110 text-white">
                            <Facebook className="h-8 w-8" />
                        </a>
                     </div>
                </div>
            </div>

            {/* Map or Image */}
            <div className="bg-[#1a1a1a] rounded-2xl border border-white/10 overflow-hidden h-full min-h-[400px] relative group">
                 <img 
                    src="https://images.unsplash.com/photo-1702644217602-c0c50e1387d0?q=80&w=1000&auto=format&fit=crop" 
                    alt="Antalya Map" 
                    className="w-full h-full object-cover opacity-50 group-hover:opacity-70 transition-opacity duration-500"
                 />
                 <div className="absolute inset-0 flex items-center justify-center">
                    <a href="https://wa.me/905468953037" target="_blank" rel="noopener noreferrer">
                        <Button className="bg-green-600 hover:bg-green-700 text-white text-xl py-8 px-12 rounded-full shadow-2xl shadow-green-900/50 animate-pulse">
                            WhatsApp ile Konum İste
                        </Button>
                    </a>
                 </div>
            </div>
         </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
